/**
 * Converts polar coordinates to Cartesian (x, y) on a unit circle of the given radius.
 * @author Copilot
 */
export const polarToCartesian = (cx: number, cy: number, radius: number, angleDegrees: number) => {
  const radians = (angleDegrees * Math.PI) / 180;
  return {
    x: cx + radius * Math.cos(radians),
    y: cy + radius * Math.sin(radians),
  };
};

/**
 * Builds an SVG arc path string between two angles on a circle.
 * @author Copilot
 */
export const describeArcSegment = (
  cx: number,
  cy: number,
  radius: number,
  startAngle: number,
  endAngle: number,
) => {
  const start = polarToCartesian(cx, cy, radius, startAngle);
  const end = polarToCartesian(cx, cy, radius, endAngle);
  const largeArcFlag = endAngle - startAngle <= 180 ? 0 : 1;
  return `M ${start.x} ${start.y} A ${radius} ${radius} 0 ${largeArcFlag} 1 ${end.x} ${end.y}`;
};
